<button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="menu" nzPlacement="topRight" nzTrigger="click" style="margin: 0px;padding: 0px;height: 16px;">
    <i nz-icon nzType="global" nzTheme="outline"></i> {{currentLanguage}}</button>
<nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item *ngFor="let language of languages" (click)="changeLanguage(language)">
            <!-- <nz-avatar nzShape="circle" [nzText]="language.code.toUpperCase()"></nz-avatar> -->
            {{language.label}}
        </li>
    </ul>
</nz-dropdown-menu>
